import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_LOAD_EMAIL_TEMPLATES_BEGIN,
  SCHEDULE_LOAD_EMAIL_TEMPLATES_SUCCESS,
  SCHEDULE_LOAD_EMAIL_TEMPLATES_FAILURE,
  SCHEDULE_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR,
} from './constants';

export function loadEmailTemplates(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_LOAD_EMAIL_TEMPLATES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${
          process.env.REACT_APP_BUILDER_ENGINE
        }v${version}/projects/${projectId}/templates?templateType=${'EMAIL'}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_LOAD_EMAIL_TEMPLATES_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_LOAD_EMAIL_TEMPLATES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEmailTemplatesError() {
  return {
    type: SCHEDULE_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_LOAD_EMAIL_TEMPLATES_BEGIN:
      return {
        ...state,
        loadEmailTemplatesPending: true,
        loadEmailTemplatesError: null,
      };

    case SCHEDULE_LOAD_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loadEmailTemplatesPending: false,
        loadEmailTemplatesError: null,
        emailTemplates: action.data,
      };

    case SCHEDULE_LOAD_EMAIL_TEMPLATES_FAILURE:
      return {
        ...state,
        loadEmailTemplatesPending: false,
        loadEmailTemplatesError: action.data.error,
      };

    case SCHEDULE_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR:
      return {
        ...state,
        loadEmailTemplatesError: null,
      };

    default:
      return state;
  }
}
